import React from "react"

import * as textSectionStyles from "../styles/TextSection.module.css"

import { ChildSelector } from "../helpers/ChildSelector"

export default function GenericSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `text-title`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )
  
  const text = ChildSelector.select(
    content,
    `text-content`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )
  return (
    <>
      <div className={`row justify-content-center ${props.className} ${textSectionStyles.wrapper}`}>
        <div className={`col-12 ${textSectionStyles.content}`}>
          <h2
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
          <p>{text}</p>
        </div>
      </div>
    </>
  )
}
